import React, { useEffect } from "react";
import { Button, Card, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import mailIcon from "../../assets/img/mail.svg";
import Divider from "@mui/material/Divider";
import "../ShoppingCart/ShoppingCartStyle.scss";
import { useDispatch, useSelector } from 'react-redux';
import { userLogout } from "../../redux/actions/UserActions";

function PaymentSuccess() {
  const { paymentDetails } = useSelector(state => state.paypal);
  const { paymentIntent } = useSelector(state => state.cart);
  const dispatch = useDispatch();

  // Extract data from paymentDetails (PayPal)
  const paypalData = paymentDetails ? {
    amount: paymentDetails.amount,
    createdAt: paymentDetails.created_at,
    email: paymentDetails.email,
    userId: paymentDetails.user_id,
    sessionId: paymentDetails.session_id,
    redirectUrl: paymentDetails.redirect_url,
    jwt: paymentDetails.jwt,
    paymentType: 'USD'
  } : null;

  // Extract data from paymentIntent (Stripe)
  const stripeData = paymentIntent ? {
    amount: paymentIntent.amount, // Convert from cents to dollars
    createdAt: paymentIntent.created_at,
    email: paymentIntent.email,
    userId: paymentIntent.user_id,
    sessionId: paymentIntent.session_id,
    redirectUrl: paymentIntent.redirect_url,
    jwt: paymentIntent.jwt,
    paymentType: 'USD'
  } : null;

  // Use whichever payment data is available
  const paymentData = paypalData || stripeData;

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(userLogout());
    
    // Block browser back button
    const preventBackNavigation = (e) => {
      // This is needed to prevent the back action
      window.history.pushState(null, null, window.location.href);
      
      // Show a message to the user (optional)
      // window.alert('You cannot go back from this page. Please use the "Go to Courses" button.');
    };

    // Push a new entry to the history stack
    window.history.pushState(null, null, window.location.href);
    
    // Add event listener for popstate
    window.addEventListener('popstate', preventBackNavigation);

    // Clean up the event listener when component unmounts
    return () => {
      window.removeEventListener('popstate', preventBackNavigation);
    };
  }, [dispatch]);

  const courseUrl = new URL(`${paymentData.redirectUrl}/ext/login/${paymentData.email}/${paymentData.sessionId}`).toString();

  return (
    <div className="shopingCart-wrap">
      <div className="purchase-sec">
        <Typography className="main-heading">Purchase Successful</Typography>
        <Card className="purchase-wrap">
          <div className="success-icon-div">
            <div className="svg-icon">
              <CheckCircleIcon />
            </div>
            <Typography label="h1" className="heading">
              Your Purchase is Complete!
            </Typography>
          </div>

          <div className="message-wrap">
            <img src={mailIcon} alt="mailIcon" />
           Check your inbox for an email with your purchase confirmation.
          </div>

          <div className="payment-des">
            <div className="purchase-dt-des">
              <Typography className="heading-lbl">Purchase Date:</Typography>
              <Typography className="sub-heading-lbl">
                {paymentData.createdAt}
              </Typography>
            </div>
            <div className="purchase-dt-des">
              <Typography className="heading-lbl">Total Amount:</Typography>
              <Typography className="sub-heading-lbl">
                {`$${paymentData.amount} ${paymentData.paymentType}`}
              </Typography>
            </div>
          </div>
          <Divider />
          <div className="btn-wrap">
           <Button 
              className="btn-cource" 
              href={courseUrl} 
            >
              Go to Courses
            </Button>
          </div>
        </Card>
        {/* <div className="help-wrap">
          <div className="help-sec">
            <Typography label="p">
              <span> Need Help?</span>
              <br />
              If you have any questions, call us +1785 98403 4 or contact
              customer@cdlscholl.com
            </Typography>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default PaymentSuccess;